module.exports = __webpack_public_path__ + "static/media/2i_background.8f569bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/2i_background.png
// module id = 2447
// module chunks = 0